import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { URI } from "../../configs";


export const loginUser = createAsyncThunk(
  "userLogin/postLogin",
  async (arg) => { // <-- destructure getState method

    //const apiUrl = URI + "api/v1/token/login/"
    const apiUrl = URI + "api/v1/token/login/"
    var config = {
      method: "post",
      url: apiUrl,
      data: arg,
      headers: {
        accept: "application/json",
      },
    };

    const response = await axios(config);
    const data = await response.data;
    return data;
  }
);


export const logoutUser = createAsyncThunk(
  "header/postLogout",
  async (arg) => {
    const apiUrl = URI + "api/v1/token/logout/"
    const token = arg.token
    //const apiUrl = "https://test.digitsolution.space/api/v1/token/logout/";
    var config = {
      method: "post",
      url: apiUrl,
      data: arg,
      headers: {
        accept: "application/json",
        Authorization: `Token ${token}`
      },
    };

    const response = await axios(config);
    const data = await response.data;
    return data;
  }
);
